import { render, staticRenderFns } from "./user-actions.vue?vue&type=template&id=21e582fd"
import script from "./user-actions.vue?vue&type=script&lang=js"
export * from "./user-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports